import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 550px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding-block: 20px;
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .content{
            padding: 20px;
            p{
                font-weight: var(--font-weight-lg);
                font-size: var(--font-size-md);
                padding: 10px 25px;
                border-radius: 10px;
                background-color: ${({ theme }) => theme.secondaryBgColor};
                margin-block: 10px;
            }
        }
        .btn{
            padding-inline: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            button{
                margin-inline: 10px;
            }
        }
    }

    @media (max-width: 850px) {

        .modal{
            width: 100vw;
            height: 100vh;
            justify-content: flex-start;
            gap: 40px;

        }

    }

`
    
const AdminAraclarMuayeneModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {muayeneBilgi} = useSelector(state => state.admin2)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    // //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <PageTopTitle title={"Muayene Sorgulama"}/>
            <div className="content">
                <p>Plaka: {muayeneBilgi?.plaka}</p>
                <p>Muayene Geçerlilik Tarihi: {muayeneBilgi?.muayeneGecerlilikTarihi}</p>
            </div>
            <div className="btn">
                <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" bgColor="#E85446" color={"#fff"}>Kapat</Button>
            </div>
        </div>
    </Container>
  )
}

export default AdminAraclarMuayeneModal